<template>
  <div>
    <div v-if="!dataStore.taxbool && dataStore.oneFileSelected" class="no-data-screen">
      {{ t('result_view.tax_groups.no_data_selected') }}
    </div>
    <div v-else-if="!dataStore.taxbool && !dataStore.oneFileSelected" class="no-data-screen">
      {{ t('result_view.tax_groups.no_data') }}
    </div>
    <div v-else class="tab-view-tax">
      <table class="tax-table">
        <tr class="table-header">
          <th class="table-header-item entry-left-edge-tax" style="width: 7%;">{{ t('result_view.tax_groups.taxg') }}</th>
          <th class="table-header-item">{{ t('result_view.tax_groups.percent') }}</th>
          <th class="table-header-item">{{ t('result_view.tax_groups.amount') }}</th>
          <th class="table-header-item">{{ t('result_view.tax_groups.tax') }}</th>
          <th class="table-header-item">{{ t('result_view.tax_groups.net') }}</th>
          <th class="table-header-item" style="width: 10%;"></th>
        </tr>
        <tr v-for="(tax, index) in dataStore.taxGroups" :key="index" class="table-entry">
          <td class="table-entry-item entry-left-edge-tax">{{ tax.TaxG }}</td>
          <td class="table-entry-item">{{ tax.Prc }}%</td>
          <td class="table-entry-item">{{ tax.Amt.toFixed(2) }}</td>
          <td class="table-entry-item">{{ tax.TAmt.toFixed(2) }}</td>
          <td class="table-entry-item">{{ tax.Net.toFixed(2) }}</td>
          <td class="table-entry-item entry-right-edge"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script setup>
import { useDataStore } from '@/stores/dataStore.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const dataStore = useDataStore()
</script>

<style scoped>
.no-data-screen {
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}

.tab-view-tax {
  padding: 20px;
}

.tax-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.table-header {
  background-color: var(--background-color-secondary);
  color: var(--text-primary-color);
}
.table-header-item {
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  width: 7%;
  padding: 0 0 0 15px
}

.table-entry {
  background-color: var(--light-grey-background-color);
  font-weight: 400;
  font-size: 15px;
  height: 46px;
  margin-bottom: 5px;
}
.table-entry-item {
  text-align: left;
  padding-left: 15px;
}

.entry-left-edge-tax {
  border-radius: 4px 0 0 4px; 
  text-align: left;
}

.entry-right-edge {
  border-radius: 0 4px 4px 0;
}
</style>